import React, { useContext, useState } from 'react';
import UserProvider from '../../context/UserContext';
import toast from 'react-hot-toast';
import { Checkbox } from '@material-ui/core';

export const CardJoinConfirmation = () => {
    
    const Context = useContext(UserProvider.context);
    const userData = Context.user;

    const [enabled, setEnabled] = useState(false);

    const handleShowEnterWaitlist = () => {
        Context.setEnterWaitlist(!Context.showEnterWaitlist)
    }

    const handleCheckbox = (e) => {
        setEnabled(e.target.checked)
    }

    const fetch_country_code_cloudflare = async() => {
        
        try {
            let url = "https://1.1.1.1/cdn-cgi/trace"

            const response = await fetch(url, {
                headers: {'Content-Type': 'text/plain; charset=uft-8'},
                method: 'GET',
                mode: 'cors'
            })
            
            if(response.status === 200){
                let data = await response.text()
                data = data.replace(/[\r\n]+/g, '","').replace(/\=+/g, '":"');
                data = '{"' + data.slice(0, data.lastIndexOf('","')) + '"}';
                let jsondata = JSON.parse(data);
                if(jsondata.loc){
                    return jsondata.loc
                }
                else{
                    return fetch_country_code_ipinfo()
                }
            }
            else {
                return fetch_country_code_ipinfo()
            }
        }   
        catch(err){
            return fetch_country_code_ipinfo()
        }
    }

    const fetch_country_code_ipinfo = async() => {

        try {
            let url = "https://ipinfo.io/?token=c6b171457ac212"
            const response = await fetch(url, {
                headers: {'Content-Type': 'text/plain; charset=uft-8'},
                method: 'GET',
                mode: 'cors'
            })

            if(response.status === 200){
                let data = await response.text()
                let jsondata = JSON.parse(data);
                return jsondata.country
            }
            else {
                return undefined
            }
        }
        catch (err) {
            return undefined
        }
    }


    const handleEnterWaitlist = async() => {

        if(enabled){
            const url = `${process.env.REACT_APP_API_URL}/waitlist/`
            setEnabled(false)
            
            var country_code = await fetch_country_code_cloudflare()

            if(!country_code){
                toast.error('Unable to join the waitlist, disable all ad blockers');
                setEnabled(true)
                return
            }

            const form = new FormData()
            form.append('country', country_code)
            
            fetch(url, {
                credentials: "include",
                method: 'POST',
                body: form
            })
            .then(function (response) {
                if(response.status === 200){
                    //alertError("Success")
                    toast.success('Successfuly joined');
                    setTimeout(() => { 
                        Context.setWaitlisted(true) 
                        Context.setEnterWaitlist(false)
                    }, 1500); 
                }
                else if(response.status === 400){
                    response.json().then(function(data){
                        if(data.code === "ALREADY_IN_WAITLIST") {
                            //alertError("Already waitlisted")
                            toast.error('Already joined the waitlist');
                            setTimeout(() => { 
                                Context.setWaitlisted(true) 
                                Context.setEnterWaitlist(false)
                            }, 1500);                                
                        }
                        else if(data.code === "ALREADY_USER") {
                            //alertError("Already user")
                            toast.error('Already owning Infinit');
                            setTimeout(() => { 
                                Context.setIsUser(true) 
                                Context.setEnterWaitlist(false)
                            }, 1500); 
                        }
                        else if(data.code === "DOES_NOT_QUALIFY") {
                            //alertError("Your account doesn't qualify")
                            toast.error(`Your account doesn't qualify`);
                            setTimeout(() => { 
                                Context.setBanned(true) 
                                Context.setEnterWaitlist(false)
                            }, 1500);
                        }
                        else{
                            toast.error('Unable to join the waitlist');
                        }
                    })
                }
                else{
                    toast.error('Unable to join the waitlist');
                }
                setEnabled(true)
            })
            .catch(err => {
                toast.error('Unable to join the waitlist');
                setEnabled(true)
                console.log(err)
            });
        }
    }
    //<input type="checkbox" className="join-confirmation-terms-checkbox" onClick={handleCheckbox}/>

    return(
        <div className="card-component card-join">
            <div className="card-content">
                <div className="join-confirmation-close-handle">
                    <button className="join-confirmation-close" onClick={handleShowEnterWaitlist}><p>&#x2715;</p></button>
                </div>
                <div className="join-confirmation-handle">
                    <h2 className="join-confirmation-title">Are you sure?</h2>
                    <ul className="join-confirmation-text-handle">
                        <li className="join-confirmation-text">Infinit Bot must be purchased and bound to this Discord account</li>
                        <li className="join-confirmation-text">Waitlist position can’t be transferred</li>
                        <li className="join-confirmation-text">Purchase link will be emailed to <b>{userData.email}</b></li>
                        <li className="join-confirmation-text">Purchase link will expire after 24 hours from receiving the email</li>
                    </ul>
                    <div className="join-confirmation-terms-handler">
                        <div className="join-confirmation-terms-checkbox-handler">
                            <Checkbox className="join-confirmation-terms-checkbox" onClick={handleCheckbox} />   
                        </div>
                        <h3 className="join-confirmation-terms-text">I agree to the <a href="https://infinitbot.com/terms" rel="noopener noreferrer" target="_blank" className="confirmation-link">Terms & Conditions</a>, <a href="https://infinitbot.com/privacy" rel="noopener noreferrer" target="_blank" className="confirmation-link">Privacy Policy</a> and waitlist conditions</h3>
                    </div>
                    <div className="join-confirmation-button-holder">
                        <button className="join-confirmation-button" onClick={handleEnterWaitlist} disabled={!enabled}>Confirm my position<i className="fas fa-angle-right"/></button>
                    </div>
                </div>
            </div>
        </div>
    )

};